












































/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleModel, CurationInfoDTO, SectionModel } from "../../../Generated/ParticaAPI";
import ArticleTitle from "@/Ui-Components/Article/Common/ArticleTitle.vue";
import ArticleAbstract from "@/Ui-Components/Article/Common/ArticleAbstract.vue";
import ArticleSubheading from "@/Ui-Components/Article/Common/ArticleSubheading.vue";
import ArticleImages from "@/Ui-Components/Article/Common/ArticleImages.vue";
import ArticleKeywords from "@/Ui-Components/Article/Common/ArticleKeywords.vue";

import ArticleBodyExtract from "@/Ui-Components/Article/Extracted/ArticleBodyExtract.vue";
import ArticleSection from "@/Ui-Components/Article/Extracted/ArticleSection.vue";

import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { IExtractedArticle } from "../../../Models/ArticleModels/article";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";



@Component(
	{
		name: "ParticaArticleExtract",
		components: {
			ArticleTitle,
			ArticleBodyExtract,
			ArticleImages,
			ArticleAbstract,
			ArticleSubheading,
			ButtonList,
			ParticaColumnContainer,
			ParticaCard,
			ArticleSection,
			ArticleKeywords
		}
	})
export default class ParticaArticleExtract extends Vue {
	@Prop() private article: IExtractedArticle; // your data
	@Prop() private show: boolean;
	@Prop() private buttons: ButtonConfig[];
	@Prop() private title: string;
	@Prop() private issueguid: string;
	@Prop() private sections: SectionModel[];
	private active: number = 0;
	@Watch("show")
	private closed() {
		if (this.show === false) {
			// reset active tab to 'properties'
			this.active = 0;
		}
	}
	private buttonClicked(clicked: ParticaEvent) {
		this.$emit("partica-event", clicked);
	}

	private checkImage(image: any) {
		this.$emit("check-image", image);
	}
	private keyboard(val: string, event: any) {
		switch (val) {
			case "SAVE": {
				this.$emit("partica-event", { action: eParticaAction.ARTICLE_SAVE } as ParticaEvent);
				this.$nextTick(() => {
					event.srcElement.focus(); // keep focus in the input that generated the event
				});
				break;
			}
			case "CLOSE": {
				this.$emit("close", {} as ParticaEvent);
				break;
			}
		}
	}


}
